import { convertCentsToDollars } from 'utils/DataTransform/utils/index.js';
export const transform = rangeData => {
  return {
    minCostPerKM: convertCentsToDollars(rangeData.minCostPerKM),
    maxCostPerKM: convertCentsToDollars(rangeData.maxCostPerKM),
    minCostPerMin: convertCentsToDollars(rangeData.minCostPerMin),
    maxCostPerMin: convertCentsToDollars(rangeData.maxCostPerMin),
    minFlagFall: convertCentsToDollars(rangeData.minFlagFall),
    maxFlagFall: convertCentsToDollars(rangeData.maxFlagFall),
    srFlagFall: convertCentsToDollars(rangeData.srFlagFall),
    srSharePercentOnCost: convertCentsToDollars(rangeData.srSharePercentOnCost),
  };
};
